import * as React from 'react'
import { Col, Row } from 'antd'
import { injectIntl, IntlShape } from 'react-intl'
import styles from './DeliveryDetails.module.scss'
import { DeliveryLocation, DeliveryLocationData } from '../../store/DeliveryTracking/types'

interface DeliveryDetailsProps {
  displayIdentifier: string
  dropOff: DeliveryLocationData
  from?: string
  intl: IntlShape
}

const deliveryDetailsItem = (name: string, value: string) => (
  <div>
    <div className={styles.itemTitle}>{name}</div>
    <div className={styles.itemText}>{value}</div>
  </div>
)

class DeliveryDetails extends React.Component<DeliveryDetailsProps> {
  render() {
    const {
      intl: {
        formatMessage,
      },
      displayIdentifier,
      dropOff: {
        address,
      } = new DeliveryLocation({}),
      from,
    } = this.props
    const translate = (id: string, values: any = {}) => formatMessage({ id }, values)

    const displayIdentifierWidth = from ? 6 : 12
    const fromWidth = displayIdentifier ? 5 : 11

    return (
      <Row>
        { address && (
          <Col xs={23} md={10}>
            {deliveryDetailsItem(translate('shipping_address'), address)}
          </Col>
        ) }
        <Col xs={1} />
        { displayIdentifier && (
          <Col xs={displayIdentifierWidth * 2} md={displayIdentifierWidth}>
            {deliveryDetailsItem(translate('order'), displayIdentifier)}
          </Col>
        ) }
        <Col xs={1} />
        { from && (
          <Col xs={(fromWidth * 2) + 1} md={fromWidth}>
            {deliveryDetailsItem(translate('from'), from)}
          </Col>
        ) }
      </Row>
    )
  }
}

export default injectIntl(DeliveryDetails)
